import logo from "@/assets/Group-1 (3).gif";
import atmisLogo from "@/assets/AtmisGestao_Cores_FundosClaros-1_1.png";

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle: string;
}

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden" style={{ backgroundColor: "#eef1f5" }}>
      {/* Blue waves - top left corner */}
      <div className="absolute top-0 left-0 pointer-events-none z-0" style={{ width: "300px", height: "250px" }}>
        <svg viewBox="0 0 300 250" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <path d="M0 0H300C250 10 180 30 120 70C60 110 25 160 0 250V0Z" fill="#a8ddf0" opacity="0.3" />
          <path d="M0 0H200C160 10 110 30 70 65C35 95 12 140 0 200V0Z" fill="#5bbdd5" opacity="0.4" />
          <path d="M0 0H100C80 10 55 30 35 60C18 85 5 120 0 160V0Z" fill="#3ba4d1" opacity="0.5" />
        </svg>
      </div>

      {/* Blue waves - top right corner */}
      <div className="absolute top-0 right-0 pointer-events-none z-0" style={{ width: "250px", height: "200px" }}>
        <svg viewBox="0 0 250 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <path d="M250 0H0C40 8 100 25 150 60C195 90 225 135 250 200V0Z" fill="#a8ddf0" opacity="0.2" />
          <path d="M250 0H80C110 8 150 25 185 55C215 80 238 115 250 150V0Z" fill="#5bbdd5" opacity="0.3" />
        </svg>
      </div>

      {/* Blue waves - bottom right corner */}
      <div className="absolute bottom-0 right-0 pointer-events-none z-0" style={{ width: "500px", height: "380px" }}>
        <svg viewBox="0 0 500 380" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <path d="M500 380H0C50 370 130 340 220 290C310 240 400 170 460 100C490 60 500 30 500 0V380Z" fill="#7ccce5" opacity="0.45" />
          <path d="M500 380H50C100 370 180 345 260 305C340 265 410 210 455 155C480 125 495 95 500 70V380Z" fill="#3ba4d1" opacity="0.65" />
          <path d="M500 380H120C170 372 240 355 310 325C380 295 435 250 465 210C485 185 498 155 500 140V380Z" fill="#2889b5" opacity="0.85" />
        </svg>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 py-10 relative z-10">
        {/* Logo */}
        <div className="mb-8">
          <img src={logo} alt="NexusQ Logo" className="w-56 md:w-72 object-contain" />
        </div>

        {/* Welcome text */}
        <h1 className="text-xl md:text-2xl font-medium text-gray-800 text-center max-w-2xl mb-10">
          {title}
        </h1>

        {/* Subtitle */}
        <p className="text-sm text-gray-500 mb-3 text-center">{subtitle}</p>

        {/* Auth form card */}
        <div className="w-full max-w-md bg-white rounded-lg border border-gray-200 px-10 py-8">
          {children}
        </div>

        {/* Support link */}
        <p className="mt-8 text-sm text-gray-500">
          Problemas para acessar?{" "}
          <a href="#" className="text-gray-600 underline hover:text-gray-800 transition-colors">
            Entre em contato com o suporte
          </a>
        </p>
      </div>

      {/* Footer */}
      <footer className="relative z-10 pb-8 flex flex-col items-center gap-3">
        <p className="text-xs text-gray-400">
          &copy; {new Date().getFullYear()} Atmis Gestão. Todos os direitos reservados.
        </p>
        <a href="/admin-login">
          <img src={atmisLogo} alt="Atmis Gestão" className="h-10 cursor-pointer" />
        </a>
      </footer>
    </div>
  );
}
